import React, { useState } from 'react'
import { Token } from '@nominex/nomiswap-sdk'
import { SlRadioButton, SlRadioGroup } from '@shoelace-style/shoelace/dist/react'
import tw from 'twin.macro'
import styled from 'styled-components'
import { TokenList } from '@uniswap/token-lists'
import { useTranslation } from 'contexts/Localization'
import ManageLists from './ManageLists'
import ManageTokens from './ManageTokens'
import { CurrencyModalView } from './types'

const StyledSlRadioGroup = styled(SlRadioGroup)`
  &::part(button-group) {
    ${tw`w-full`}
  }
`

const StyledSlRadioButton = styled(SlRadioButton)`
  &::part(button) {
    ${tw`text-white`}
  }
`

enum RadioValue {
  LISTS = '0',
  TOKENS = '1',
}

export default function Manage({
  setModalView,
  setImportList,
  setImportToken,
  setListUrl,
}: {
  setModalView: (view: CurrencyModalView) => void
  setImportToken: (token: Token) => void
  setImportList: (list: TokenList) => void
  setListUrl: (url: string) => void
}) {
  const [currentValue, setCurrentValue] = useState(RadioValue.LISTS)

  const handleChange = (event) => {
    setCurrentValue(event.target.value)
  }

  const { t } = useTranslation()

  return (
    <div className="px-24">
      <StyledSlRadioGroup className="mb-24" value={currentValue} onSlChange={handleChange}>
        <StyledSlRadioButton className="w-full" value={RadioValue.LISTS}>
          {t('Lists')}
        </StyledSlRadioButton>
        <StyledSlRadioButton className="w-full" value={RadioValue.TOKENS}>
          {t('Tokens')}
        </StyledSlRadioButton>
      </StyledSlRadioGroup>
      {
        {
          [RadioValue.LISTS]: (
            <ManageLists setModalView={setModalView} setImportList={setImportList} setListUrl={setListUrl} />
          ),
          [RadioValue.TOKENS]: <ManageTokens setModalView={setModalView} setImportToken={setImportToken} />,
        }[currentValue]
      }
    </div>
  )
}
